import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';
import { Button } from '@gem/ui-kit';

import { LogoIcon } from '../Pages/Components/LogoIcon/LogoIcon';
import { useCallFinishedPresenter } from './CallFinished.presenter';
import styles from './CallFinished.styles.m.css';

export const CallFinished: FC = observer(() => {
  const { t } = useTranslation();
  const presenter = useCallFinishedPresenter();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        {presenter.isShowLogo && <LogoIcon className={styles.logo} />}
        <h1 className={styles.title}>{t('call_finished')}</h1>
        <p className={styles.subTitle}>{t('call_finished_window_tips_message')}</p>
      </div>
      <Button
        onClick={presenter.onJoinAgain}
        className={styles.joinAgainButton}
        size="20"
        theme="primary"
      >
        {t('common_rejoin_button')}
      </Button>
    </div>
  );
});
